import { useQuery } from 'react-query';

import { getAvailableTechnicians } from 'api/clients/getAvailableTechnicians';

export const useGetAvailableTechnicians = () => {
  const { data, refetch, isLoading, isRefetching } = useQuery(
    ['availableTechnicians'],
    () => getAvailableTechnicians(),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading, isRefetching };
};

export default useGetAvailableTechnicians;
